import {Component, OnInit, Injectable} from '@angular/core';
import {ResendEmailVerificationRequest, Stormpath} from 'angular-stormpath';

@Component({
    template: require('./resend-verification-page.component.html'),
    styles: [require('./resend-verification-page.component.scss')]
})
@Injectable()
export class ResendRegistrationVerificationPageComponent implements OnInit {

    protected error: string;
    protected formModel: ResendEmailVerificationFormModel;
    protected posting: boolean;
    protected sent: boolean;

    constructor(public stormpath: Stormpath) {
    }

    ngOnInit(): void {
        this.posting = false;
        this.sent = false;
        this.formModel = {
            email: ''
        };
    }

    send(): void {
        this.posting = true;
        this.stormpath.resendVerificationEmail(this.formModel as any as ResendEmailVerificationRequest)
            .subscribe(() => {
                this.posting = false;
                this.sent = true;
            }, (error) => {
                this.posting = false;
                this.error = error.message;
            });
    }

    onSubmit(): void {
        this.send();
    }
}

class ResendEmailVerificationFormModel {
    email: string;
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./~/tslint-loader!./src/app/pages/register/resend-verification/resend-verification-page.component.ts